<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="elevation-12">
          <v-toolbar dark color="light-blue">
            <v-toolbar-title>Sign up</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container fluid>
            <v-card-text>
              <v-text-field prepend-icon="email" name="email" label="Email" type="text" v-model="email" ></v-text-field>
              <v-text-field prepend-icon="lock" name="password" label="Password" type="password" v-model="password"></v-text-field>
              <v-text-field prepend-icon="lock" name="password" label="Confirm Password" type="password" v-model="passwordConfirm"></v-text-field>
            </v-card-text>
            <v-btn class="info" dark v-on:click="register()">Register</v-btn>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  export default {
    data () {
      return {
        email: '',
        password: '',
        passwordConfirm: ''
      }
    },
    methods: {
      register: function () {
        if(this.email==='' || this.password === '' || this.passwordConfirm === '') {
          EventBus.$emit('send-notification', {text: 'Missing required fields'});
          return;
        }
        if(!this.validateEmail(this.email)) {
          EventBus.$emit('send-notification', {text: 'Please enter a valid email address'});
          return;
        }
        if(this.password !== this.passwordConfirm) {
          EventBus.$emit('send-notification', {text: 'Passwords do not match'});
          return;
        }
        if(!this.validatePassword(this.password)) {
          EventBus.$emit('send-notification', {text: 'Password must be at least 8 characters long and have at least 1 digit'});
          return;
        }
        var username = this.email.split('@')[0];
        this.$http.post(this.$store.state.serverHttpUrl+'/register', {
          email: this.email,
          username: username,
          password: this.password
        }).then(function(response) {
          EventBus.$emit('send-notification', {text: 'User account successfully created', color: 'success'});
          setTimeout(() => {
            this.$router.push('/');
          }, 1000);
        }, function (err) {
          EventBus.$emit('send-notification', {text: err.body});
        });
      },
      validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      validatePassword(pw) {
        var regex = /^(?=.*\d)[a-zA-Z0-9]{8,}$/;
        return regex.test(pw);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Signup/AppSignup.vue